import React, { useEffect, useState } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import Header from './header/Header';
import Footer from './Footer';
import { Location } from '@reach/router';
import './layout.scss';
import LanguageProvider from '../i18n/LanguageProvider';

const Layout = ({ locale, children }) => {
	const imageQuery = useStaticQuery(
		graphql`
			query {
				rannateeLogo: file(
					sourceInstanceName: { eq: "SharedImages" }
					relativePath: { eq: "rannatee-logo.png" }
				) {
					childImageSharp {
						fixed(width: 126) {
							...GatsbyImageSharpFixed
						}
					}
				}
				leaderLogo: file(
					sourceInstanceName: { eq: "GalleryImages" }
					relativePath: { eq: "leader/leader-logo.png" }
				) {
					childImageSharp {
						fixed(width: 126) {
							...GatsbyImageSharpFixed
						}
					}
				}
				leaderLogo2: file(
					sourceInstanceName: { eq: "GalleryImages" }
					relativePath: { eq: "leader/leader-logo-2.png" }
				) {
					childImageSharp {
						fixed(width: 154) {
							...GatsbyImageSharpFixed
						}
					}
				}
				euLogo: file(
					sourceInstanceName: { eq: "GalleryImages" }
					relativePath: { eq: "leader/eu-logo.png" }
				) {
					childImageSharp {
						fixed(width: 126) {
							...GatsbyImageSharpFixed
						}
					}
				}
			}
		`
	);

	const [footerLogos, setFooterLogos] = useState(null);

	useEffect(() => {
		if (imageQuery) setFooterLogos(imageQuery);
	}, [imageQuery]);

	return (
		<div>
			<LanguageProvider locale={locale}>
				<Location>
					{({ location }) => (
						<>
							<Header location={location.pathname} />
							<div className='page'>{children}</div>
							<Footer logos={footerLogos} />
						</>
					)}
				</Location>
			</LanguageProvider>
		</div>
	);
};

export default Layout;
